import getBecomeProducerPage from './getBecomeProducerPage'
import getBlogPage from './getBlogPage'
import getDynamicTariffPage from './getDynamicTariffPage'
import getEncyclopediaPage from './getEncyclopediaPage'
import getPriceListPage from './getPriceListPage'
import getPricingPage from './getPricingPage'
import getProductPage from './getProductPage'

const pages = {
  getBecomeProducerPage,
  getBlogPage,
  getDynamicTariffPage,
  getEncyclopediaPage,
  getPriceListPage,
  getPricingPage,
  getProductPage
}

export default pages
